function addCount() {
  setTimeout(function () {
    var activeProducts = $('.tt-col-item.shown').not('.tt-col-item.tt-logo-col.shown, .tt-logo-col .tt-col-item.shown').length;
    $('.addCount').html('(' + activeProducts + ')')
  }, 100)
}
addCount()
$('.filter-item').click(function (e) {

  $('.tt-col-item').removeClass('shown');
  addCount()
  $(this).toggleClass('active');
  var clickedItems = $('.filter-item.active');

  filter = []
  clickedItems.each(function () {
    filter.push($(this).text())
  })

  console.log(filter)

  $('.active-tags span').remove()

  //urls
  filter_urls = []
  clickedItems.each(function () {
    filter_urls.push($(this).text().toLowerCase().replace(/ /g,'').replace('-','').replace('&',''))
  })
  console.log(filter_urls)
  var filters_url = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filters=' + filter_urls + '&sort_by=' + get_sort;
  window.history.pushState({ path: filters_url }, '', filters_url);



  filter.forEach(function(item) {
    $('.active-tags').append(`<span class="active-tag">${item}</span>`)
  })
  if(filter.length < 1) {
    $('.tt-col-item.products-group').addClass('shown');
    addCount()
    var clear_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.pushState({ path: clear_url }, '', clear_url);
  }



  $('.tt-col-item').each(function() {
    if($(this).attr('data-tags') != undefined) {
      var tags_Arr = $(this).attr('data-tags').split(',')
      var filteredArray = tags_Arr.filter(value => filter.includes(value));
      if(filteredArray.length > 0) {
        $(this).addClass('shown');
      }
    }
  })
})
$(document).on('click', '.active-tag',function() {
  var removalTag = $(this).text()
  $(`.filtres-js .filter-item.active:contains('${removalTag}')`).click()
});


Shopify.queryParams = {};

// Preserve existing query parameters
if (location.search.length) {
  var params = location.search.substr(1).split('&');

  for (var i = 0; i < params.length; i++) {
    var keyValue = params[i].split('=');

    if (keyValue.length) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
    }
  }
}

// Update sort_by query parameter on select change
document.querySelector('#sort-by').addEventListener('change', function(e) {
  var value = e.target.value;

  Shopify.queryParams.sort_by = value;
  location.search = '?filters=' + filter_urls + '&' + new URLSearchParams(Shopify.queryParams).toString()
});
